import request from '@/utils/request'
import { IFBConvRequest } from '@/interfaces/fbconv'
import { AxiosPromise } from 'axios'

export function sendFBConv (data: IFBConvRequest): AxiosPromise<any> {
  return request({
    url: '/fconv/fb_send_event.php',
    method: 'post',
    data
  })
}
